<template>
    <div class="aipage">
        <div class="banner-img background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/factory/bannerWrap.png')})`}">
            <div class="banner">
                <div class="banner-title background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/factory/bannerTitle.png')})`}"></div>
                <div class="banner-smallTitle">AI工厂，以智能算力为基座，汇聚模型平台服务、模型API服务、智能工作流服务的高效引擎，为全球用户提供从芯片级算力支持到智能体应用的全栈式解决方案，加速AI创新。</div>
            </div>
        </div>
     
        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/factory/fact_bg2.png')})`, height:'6.6rem' }">
            <div class="aipage_content" style="width: 10rem;">
                <p class="titleBlue">服务内容</p>
                <div class="flex-between">
                   <div class="service_content" v-for="(item,index) in serviceList" :key="index" @click="selectService(index)" :class="{ active: selectedServiceIndex === index }">
                        <div class="service_content-icon background" :style="{ 'backgroundImage' : `url(${selectedServiceIndex === index ? item.iconActive : item.icon})`}"></div>
                        <div class="service_content-title">{{ item.title }}</div>
                   </div>
                </div>
                <div class="flex-between service-content-wrap">
                    <div class="service-wrap-left">
                        <div class="service-wrap-left-title">{{ serviceList[selectedServiceIndex].title }}</div>
                        <div class="service-wrap-left-subTitle">{{ serviceList[selectedServiceIndex].subTitle }}</div>
                        <div class="service-wrap-left-subContent" v-for="(item,index) in serviceList[selectedServiceIndex].subContentList" :key="index">
                            <div class="service-wrap-left-subContent-title"><span class="service-wrap-left-subContent-icon"></span>{{ item.title }}</div>
                            <div class="service-wrap-left-subContent-content">{{ item.content }}</div>
                        </div>
                    </div>
                    <div class="service-wrap-right background" :style="{ 'backgroundImage' : `url(${serviceList[selectedServiceIndex].contentPic})`}"></div>
                </div>             
            </div>
        </div>
        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/factory/fact_bg4.png')})`}">
            <div class="aipage_content" style="width: 11.4rem;">
                <p class="titleBlue" style="color: #fff;">服务优势</p>
                <p class="sub-title">贴近客户需求，高SLA服务的同时，保持较高的服务性价比。</p>
                <div class="flex-between">
                    <div v-for="(item,index) in advantageList" :key="index" class="advantage_content background" :style="{ 'backgroundImage' : `url(${item.background})`}">
                        <div class="advantage_content-title">{{ item.title }}</div>
                        <div class="advantage_content-content">{{ item.content }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
export default {
    props: {
        content: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedServiceIndex: 0,
            serviceList:[
                {
                    icon: require('@/assets/images/bussiness/factory/service1.png'),
                    iconActive: require('@/assets/images/bussiness/factory/service1_active.png'),
                    title: '智能算力服务',
                    subTitle:'异构弹性算力支持',
                    contentPic: require('@/assets/images/bussiness/factory/service1_content.png'),
                    subContentList:[
                      { title:'混合算力', content:'兼容英伟达/国产芯片（寒武纪/海光/沐曦）'},
                      { title:'极速扩容', content:'秒级调配千卡资源，训练稳定性99.9%'},
                    ],
                },
                {
                    icon: require('@/assets/images/bussiness/factory/service2.png'),
                    iconActive: require('@/assets/images/bussiness/factory/service2_active.png'),
                    title: '模型API超市',
                    subTitle:'常用大模型的标准API服务，提供海外加速',
                    contentPic: require('@/assets/images/bussiness/factory/service2_content.png'),
                    subContentList:[
                      { title:'开箱即用', content:'deepseek、Qwen、Llama等主流模型，标准openAPI接口。'},
                      { title:'全球加速能力', content:'海外访问延迟<200ms'},
                    ],
                },
                {
                    icon: require('@/assets/images/bussiness/factory/service3.png'),
                    iconActive: require('@/assets/images/bussiness/factory/service3_active.png'),
                    title: '模型开发平台',
                    subTitle:'涵盖预训练模型库与自动化调优工具，支持模型开发、训练与优化全流程',
                    contentPic: require('@/assets/images/bussiness/factory/service3_content.png'),
                },
                {
                    icon: require('@/assets/images/bussiness/factory/service4.png'),
                    iconActive: require('@/assets/images/bussiness/factory/service3_active.png'),    
                    title: '模型调优服务',
                    subTitle:'',
                    contentPic: require('@/assets/images/bussiness/factory/service3_content.png'),
                },
                {
                    icon: require('@/assets/images/bussiness/factory/service5.png'),
                    iconActive: require('@/assets/images/bussiness/factory/service3_active.png'),    
                    title: '创意工作流',
                    subTitle:'',
                    contentPic: require('@/assets/images/bussiness/factory/service3_content.png'),
                },
            ],
            advantageList:[
                {
                    title:'全周期陪伴',
                    content:'从模型开发到落地，匹配企业各阶段需求，提供算法/数据/算力全栈支持。',
                    background: require('@/assets/images/bussiness/factory/advantage1.png'),
                },
                {
                    title:'省钱',
                    content:'按实际用量阶梯计费，中小客户可节省40%成本',
                    background: require('@/assets/images/bussiness/factory/advantage2.png'),
                },
                {
                    title:'省心',
                    content:'99.95%高可用性、95%请求响应<300ms、故障 恢复≤15分钟',
                    background: require('@/assets/images/bussiness/factory/advantage3.png'),
                },
            ]
        }
    },
    mounted() {
        // 页面加载时回到顶部
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },

    beforeDestroy() {
        // 移除滚动监听，避免内存泄漏
        window.removeEventListener('scroll', this.scrollHandler);
    },

    methods: {
        // 节流函数：限制事件触发频率
        throttle(fn, delay) {
            let lastTime = 0;
            return function(...args) {
                const now = Date.now();
                if (now - lastTime > delay) {
                lastTime = now;
                fn.apply(this, args);
                }
            };
        },

        // 检测元素是否进入视图范围
        isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            // 元素顶部进入视图底部80%位置时判定为可见（优化触发时机）
            return rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8;
        },

        selectService(index) {
            this.selectedServiceIndex = index;
        }
    }
}
</script>


<style lang="scss" scoped>
// 入场动画关键帧定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.banner {
  left: 20%;
  top: 1.4rem;
  animation: fadeIn 0.8s ease-out forwards; /*  banner区域入场动画 */
  opacity: 0;
  &-title {
    width: 2rem;
    height: 1.4rem;
    background-size: contain;
  }
  &-smallTitle {
    color: #fff;
    width: 8rem;
    letter-spacing: 2px;
    line-height: 0.24rem;
    font-size: 0.14rem;
    animation-delay: 0.3s; /* 标题文字延迟出现 */
    opacity: 0;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.background {
  background-position: center;
  background-repeat: no-repeat;
}

.banner-img {
  width: 100%;
  height: 2.8rem;
  position: relative;
  background-size: cover;
}

.titleBlue {
  font-size: 0.3rem;
  color: #0061e3;
  font-weight: 600;
  letter-spacing: 0.05rem;
  text-align: center;
  height: 0.6rem;
  margin: 0.2rem 0;
  font-family: '黑体';
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  animation-delay: 0.2s;
}
.sub-title{
    font-size: 0.14rem;
    color: #f8f8f8;
    letter-spacing: 0.01rem;
    text-align: center;
    position: relative;
    top:-0.2rem;
}
 @media screen and (min-width: 2000px) {
    .banner {
      &-smallTitle {
        font-size: 0.12rem;
      }
      &-title {
        width: 1.8rem;
        height: 1.2rem;
      }
    }
    
    .titleBlue {
      font-size: 0.26rem;
    }
    .service-item-title {
      font-size: 0.15rem;
    }

    .service-item-text {
      font-size: 0.14rem;
    }
    .case-item-label {
      font-size: 0.16rem;
    }
    .service-wrap-left-title{
      font-size: 0.16rem;
    }
    .service-wrap-left-subTitle{
        font-size: 0.13rem;
    }
    .service-wrap-left-subContent-title{
        font-size: 0.14rem;
    }
    .service-wrap-left-subContent-content{
        font-size: 0.12rem;
    }
    .advantage_content-title{
        font-size: 0.16rem;
    }
    .advantage_content-content{
      font-size: 0.13rem;
    }
}
</style>

<style lang="scss">
.aipage {
  .el-button--small {
    padding: 0.1rem 0.4rem;
    border-color: #0061e3;
    color: #0061e3;
    font-weight: 600;
    border-radius: 0;
    transition: all 0.3s ease;
  }
  .el-button--small:hover {
    background-color: #0061e3;
    color: #fff;
    transform: translateY(-2px);
  }
}

.aipage_wrap {
  width: calc(100% - 0.48rem);
  display: flex;
  justify-content: center;
  padding: 0.24rem;
  background-color: #f5f5f5;
}

.aipage_content {
  width: 12rem;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.flex-wrap {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.dot-w {
  display: inline-block;
  width: 0.08rem;
  height: 0.08rem;
  background-color: #fff;
  border-radius: 50%;
}

.el-divider--horizontal {
  margin: 0.16rem 0;
}

.banner-btn{ 
  width: 3.2rem; 
  padding: 0.02rem;
  background: #4C4C4C;
  text-align: center;
  border-radius: 0.04rem;
  display: flex;
  justify-content: space-between;
}
.banner-btn-item{
    display: inline-block;
    font-size: 0.16rem;
    border-radius: 0.04rem;
    padding:0.04rem 0.2rem;
    font-weight: 600;
    color: #A8A8A8;
    cursor: pointer;
}
.banner-btn-item-active{
    color: #fff;
    background: #0463D8;
}

.service_content {
  width: 0.9rem;
  height: 1.36rem;
  cursor: pointer;
  transition: all 0.3s ease;
  &.active { 
    .service_content-title {
      color: #0061E3;
    }
    border-bottom: 0.03rem solid #0061E3;
  }
  &-icon {
    width: 0.72rem;
    height: 0.7rem;
    background-size: contain;
    margin: 0.1rem auto;
  }
  &-title {
    font-size: 0.14rem;
    font-weight: 500;
    color: #333;
    text-align: center;
    margin-top: 0.2rem;
    transition: color 0.3s ease;
  }
}
.service-content-wrap{
    width: 10rem;
    height: 3.6rem;
    margin-top: 0.4rem;
}
.service-wrap-left{
    width: 3rem;
}
.service-wrap-left-title{
    font-size: 0.18rem;
    font-weight: 600;
    color: #333;
    text-align: left;
    transition: color 0.3s ease;
}
.service-wrap-left-subTitle{
    font-size: 0.15rem;
    font-weight: 600;
    color: #A8A8A8;
    margin-top: 0.1rem;
    text-align: left;
    transition: color 0.3s ease;
}
.service-wrap-left-subContent{
    margin-top: 0.5rem;
    text-align: left;
    transition: color 0.3s ease;
}
.service-wrap-left-subContent-title{
    font-size: 0.15rem;
    color: #333;
    font-weight: 600;
    margin-top: 0.2rem;
}
.service-wrap-left-subContent-icon{
    display: inline-block;
    width: 0.05rem;
    height: 0.05rem;
    position: relative;
    left:-0.05rem;
    margin-left: -0.14rem;
    border: 0.03rem solid #0061E3;
    background: #eef3fa;
    border-radius: 50%;
}
.service-wrap-left-subContent-content{
    font-size: 0.13rem;
    margin-top: 0.06rem;
}
.service-wrap-right{
    width: 6.9rem;
    height: 3.2rem;
    background-size: cover;
}
.advantage_content{
   width: 3.4rem;
   height: 1.8rem;
   padding:0 0.2rem;
   margin-right: 0.2rem;
   margin-bottom: 0.2rem;
   background-size: contain;
   transition: all 0.3s ease;
}
.advantage_content-title{
    font-size: 0.17rem;
    font-weight: 600;
    color: #f1f2f3;
    text-align: center;
    margin-top: 0.75rem;
}
.advantage_content-content{
   font-size: 0.14rem;
   color: #f1f2f3;
   margin-top: 0.1rem;
}
</style>